export default __webpack_public_path__ + "static/howto-3-94f07448ff799db05d1dadb9e37b84a4.jpg";